import React from "react";
import { Modal, Button } from "react-bootstrap";

const DeleteBankModal = ({ show, bank, onClose, onConfirm }) => {
  return (
    <Modal show={show} onHide={onClose} centered backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>Confirmer la suppression</Modal.Title>
      </Modal.Header>

      <Modal.Body className="text-center">
        <p className="mb-4">
          Êtes-vous sûr de vouloir supprimer la banque{" "}
          <strong className="text-danger">{bank?.name}</strong> ?
        </p>

        <div className="d-flex justify-content-end">
          <Button variant="secondary" onClick={onClose} className="me-2">
            Annuler
          </Button>
          <Button variant="danger" onClick={() => onConfirm(bank)}>
            Supprimer
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default DeleteBankModal;
